import { CardContent, CardHeader, Typography } from '@mui/material'
import React from 'react'

export const DidYouKnow: React.FC = () => {
  return (
    <>
      <CardHeader title={<Typography variant="h6">Did you know?</Typography>} />
      <CardContent>
        <Typography variant="body2">
          Gremlin needs to see active network traffic in order for us to see
          your Service's dependencies automatically.
        </Typography>
      </CardContent>
    </>
  )
}
